import { decimal, percentage } from '../formatters';
import zeroReducer from './zeroReducer';

const labelCallback = context => {
    const yLabel = context.parsed.y;
    const dataArr = context.dataset.data;
    const total = dataArr.reduce((acc, el) => acc + el, 0);
    const formattedLabel = total
        ? `${decimal(yLabel)} (${percentage(yLabel / total)})`
        : 0;
    return formattedLabel;
};

const decimalConfig = () => {
    return {
        scales: {
            y: {
                beginAtZero: true,
                type: 'linear',
                ticks: {
                    callback: val => {
                        return zeroReducer(val);
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback,
                },
            },
        },
    };
};

export default decimalConfig;
